import React from 'react';
import { HashRouter, BrowserRouter } from 'react-router-dom';

const isElectron = navigator.userAgent.toLowerCase().includes('electron');

const AppRouter = ({ children }) => {
  const Router = isElectron ? HashRouter : BrowserRouter;
  return <Router>{children}</Router>;
};

export default AppRouter;
